import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from '../ValidationElement';
import NumberComponent from '../Number';

export default class Weight extends ValidationElement {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.handleError = this.handleError.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  /**
   * Handle the change event.
   */
  handleChange(event) {
    this.setState({ value: event.target.value }, () => {
      super.handleChange(event);
      if (this.props.onUpdate) {
        this.props.onUpdate({
          value: this.state.value,
          // value: parseInt(this.state.value)
        });
      }
    });
  }

  handleError(value, arr) {
    const arr2 = arr.map((err) => ({
      code: `weight.${err.code}`,
      valid: err.valid,
      uid: err.uid,
    }));

    // Take the original and concatenate our new error values to it
    return this.props.onError(value, arr2);
  }

  /**
   * Generated name for the part of the address elements.
   */
  partName(part) {
    return `${this.props.name}-${part}`;
  }

  render() {
    return (
      <div className="weight">
        <div className="pounds">
          <NumberComponent
            attribute={this.props.attribute}
            id={this.partName('pounds')}
            name="pounds"
            label={i18n.t('identification.traits.label.pounds')}
            disabled={this.props.disabled}
            max="999"
            maxlength="3"
            min="10"
            readonly={this.props.readonly}
            required={this.props.required}
            step="1"
            value={this.state.value}
            onChange={this.handleChange} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          />
        </div>
      </div>
    );
  }
}

Weight.defaultProps = {
  name: 'weight',
  value: '',
  onError: (value, arr) => arr,
  required: false,
};

Weight.errors = [];
